import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    showSpinner: false,
    canvasData: {},
    loginCurrentContent: 'login',
    loginHistoryContent: 'login',
    resetpasswordVerifyToken: '',
    verifyAccount: '',
    userRegions: {},
    selectedRegion: {},
    selectedMeter: {},
    realtimeData: {},
    dailyBillThisMonth: [],
    billMode: '',
    pickedFunction: 'power-overview',
    historicalDataTimeFormat: 'day',
    requestDate: '',
    selectedCircuitIds: [],
    dataType: 'barChart',
    flatPickrConfig: {
      altFormat: 'D, d M Y',
      altInput: true,
      dateFormat: 'Y-m-d',
      maxDate: null,
      minDate: null,
    },
    scaleColors: [
      { r: 252, g: 183, b: 17, a: 1 },
      { r: 243, g: 112, b: 33, a: 1 },
      { r: 204, g: 0, b: 76, a: 1 },
      { r: 100, g: 96, b: 170, a: 1 },
      { r: 0, g: 137, b: 208, a: 1 },
      { r: 13, g: 177, b: 75, a: 1 },
      { r: 109, g: 111, b: 113, a: 1 },
      { r: 13, g: 203, b: 158, a: 1 },
    ],
  },
  getters: {
    showSpinner: (state) => state.showSpinner,
    canvasContent: (state) => state.canvasData,
    loginCurrentContent: (state) => state.loginCurrentContent,
    loginHistoryContent: (state) => state.loginHistoryContent,
    resetpasswordVerifyToken: (state) => state.resetpasswordVerifyToken,
    verifyAccount: (state) => state.verifyAccount,
    userRegions: (state) => state.userRegions,
    selectedRegion: (state) => state.selectedRegion,
    selectedMeter: (state) => state.selectedMeter,
    realtimeData: (state) => state.realtimeData,
    dailyBillThisMonth: (state) => state.dailyBillThisMonth,
    billMode: (state) => state.billMode,
    pickedFunction: (state) => state.pickedFunction,
    historicalDataTimeFormat: (state) => state.historicalDataTimeFormat,
    requestDate: (state) => state.requestDate,
    selectedCircuitIds: (state) => state.selectedCircuitIds,
    dataType: (state) => state.dataType,
    flatPickrConfig: (state) => state.flatPickrConfig,
    scaleColors: (state) => state.scaleColors,
  },
  mutations: {
    setShowSpinner(state, showSpinner) {
      console.log('@@@ setShowSpinner', showSpinner);
      state.showSpinner = showSpinner;
    },
    setCanvasContent(state, { channelId, content }) {
      Vue.set(state.canvasData, channelId, content);
    },
    setLoginCurrentContent(state, content) {
      this.commit('setLoginHistoryContent', state.loginCurrentContent);
      state.loginCurrentContent = content;
    },
    setLoginHistoryContent(state, content) {
      state.loginHistoryContent = content;
    },
    setResetpasswordVerifyToken(state, token) {
      state.resetpasswordVerifyToken = token;
    },
    setVerifyAccount(state, token) {
      state.verifyAccount = token;
    },
    setUserRegions(state, userRegions) {
      state.userRegions = userRegions;
    },
    setSelectedRegion(state, region_id) {
      state.userRegions.forEach((region) => {
        if (region.id === region_id) {
          state.selectedRegion = region;
          console.log('@@@ set bill mode: ' + region.bill_mode);
          this.commit('setBillMode', region.bill_mode);
        }
      });
    },
    setSelectedMeter(state, meter) {
      console.log('@@@ set selected meter id: ' + meter.id);
      state.selectedMeter = meter;
    },
    setRealtimeData(state, realtimeData) {
      state.realtimeData = realtimeData;
    },
    setDailyBillThisMonth(state, dailyBill) {
      state.dailyBillThisMonth = dailyBill;
    },
    setBillMode(state, mode) {
      state.billMode = mode;
    },
    setPickedFunction(state, pickedFunction) {
      state.pickedFunction = pickedFunction;
    },
    setHistoricalDataTimeFormat(state, timeFormat) {
      state.historicalDataTimeFormat = timeFormat;
    },
    setRequestDate(state, requestDate) {
      console.log('@@@ set request date: ' + requestDate);
      state.requestDate = requestDate;
    },
    setSelectedCircuitIds(state, selectedCircuitIds) {
      state.selectedCircuitIds = selectedCircuitIds;
    },
    setDataType(state, dataType) {
      state.dataType = dataType;
    },
    setFlatPickrConfig(state, { firstCreateAt, latestCreateAt }) {
      state.flatPickrConfig.minDate = firstCreateAt;
      state.flatPickrConfig.maxDate = latestCreateAt;
    }
  },
  actions: {
    async setUserRegions(context) {
      console.log('@@@ call regions api');
      context.commit('setShowSpinner', true);
      await axios.get(base_url + "/api/regions/")
        .then((response) => {
          console.log('@@@ get regions success');
          let region_data = response.data.map((region) => {
            if (region.bx_meters.length > 0) {
              return {
                'id': region.id,
                'name': region.name,
                'meters': region.bx_meters,
                'bill_mode': region.bill_mode,
              };
            } else {
              return null;
            }
          }).filter((el) => el);
          context.commit('setUserRegions', region_data);
          // 若未選擇區域
          if (Object.keys(context.state.selectedRegion).length === 0) {
            console.log('@@@ set default region');
            // 預設顯示使用者的第一個區域
            context.commit('setSelectedRegion', context.state.userRegions[0].id);
          } else {
            console.log('@@@ set selected region');
            region_data.forEach((region) => {
              if (region.id === context.state.selectedRegion.id) {
                context.commit('setSelectedRegion', region.id);
              }
            })
          }
        }).catch(error => console.error(error));
    },
    setSelectedMeter({ commit, state, dispatch }, meter_id = state.selectedMeter.id) {
      console.log('@@@ call meter api');
      commit('setShowSpinner', true);
      if (!meter_id) { meter_id = state.selectedRegion.meters[0].id }
      let meter_data = '';
      state.selectedRegion.meters.forEach((meter) => {
        if (meter.id === meter_id) {
          meter_data = meter;
        }
      });
      if (!meter_data) { return }
      const time_format = state.historicalDataTimeFormat;
      const request_date = state.requestDate;

      console.log('@@@ request date: ', request_date);

      let promises = meter_data.bx_circuits.map((circuit) => {
        const axios_data = {
          year: request_date.split("-")[0],
          month: request_date.split("-")[1],
          day: request_date.split("-")[2],
          circuit_id: circuit.id,
          mac: meter_data.bx_mac,
        };
        console.log('@@@ axios data: ', axios_data);
        return axios.post(`${base_url}/api/bx/log/${time_format}`, axios_data)
          .then((response) => {
            console.log('@@@ response date: ', response.data.request_date);
            return {
              id: circuit.id,
              alias: circuit.alias,
              channels: circuit.channels,
              electricity_data: response.data.electricity_data,
              cumulative_data: response.data.cumulative_data,
            }
          })
          .catch((error) => console.error(error));
      })
      Promise.all(promises).then(circuit_data => {
        console.log('@@@ done meter api success'),
          commit('setSelectedMeter', {
            bx_circuits: circuit_data,
            bx_mac: meter_data.bx_mac,
            id: meter_data.id,
            mac_alias: meter_data.mac_alias,
          });
      });
    },
    setRealtimeData({ commit, state }) {
      console.log('@@@ call realtimeData api');
      commit('setShowSpinner', true);
      let bx_mac = state.selectedMeter.bx_mac;
      return axios.post(base_url + "/api/bx/realtimeData", {
        mac: bx_mac,
      }).then((response) => {
        console.log('@@@ get realtimeData success');
        commit('setRealtimeData', response.data.latest_data);
      }).catch(error => console.error(error));
    },
    async setRequestDate(context, mac = context.state.selectedMeter.bx_mac) {
      console.log('@@@ call requestDate api');
      context.commit('setShowSpinner', true);
      await axios.post(base_url + "/api/bx/log", { mac: mac })
        .then((response) => {
          const firstCreateAt = response.data.first_data_created_at;
          const latestCreateAt = response.data.latest_data_created_at;
          console.log('@@@ get requestDate success', latestCreateAt);
          const request_date = latestCreateAt;
          context.commit('setRequestDate', request_date);
          context.commit('setFlatPickrConfig', { firstCreateAt, latestCreateAt });
        }).catch((error) => console.error(error));

      return
    }
  },
});

export default store;
